module.exports = __webpack_public_path__ + "img/1946.288e9f73.png";